<template>
    <div>
        <hts-tooltip
            ref="tooltip"
            trigger="click">
            <template #reference>
                <hi-pencil-square-icon class="text-warning-600 hover:text-warning-600 cursor-pointer h-6 w-6" />
            </template>
            <span>
                <div class="flex flex-col gap-3 w-64">
                    <hts-form-input
                        v-model="productivity"
                        :label="$t('labels.productivityOrder')"
                        type="number" />

                    <p class="text-xs text-error-500">
                        {{ errorMessage }}
                    </p>
                    <hts-form-button
                        :disabled="!!errorMessage"
                        type="button"
                        color="info"
                        @click="submit">
                        Xác nhận
                    </hts-form-button>
                </div>
            </span>
        </hts-tooltip>
    </div>
</template>
<script lang="ts" setup>
import { computed, toRefs, watch, ref, onMounted } from 'vue'

const props = defineProps({
  productivityOrder: {
    type: Number,
    required: true
  },
  allotted: {
    type: Number,
    required: true
  },
  orderId: {
    type: Number,
    required: true
  }
})

const emits = defineEmits(['update'])

const productivity = ref(0)
const tooltip = ref()

const { productivityOrder, allotted, orderId } = toRefs(props)

onMounted(() => {
  productivity.value = productivityOrder.value
})

watch(
  () => productivityOrder.value,
  (val) => {
    productivity.value = val
  }
)

const errorMessage = computed(() => {
  let error = ''

  if (!productivity.value || productivity.value < allotted.value) {
    error = 'Tổng sản lượng của đơn hàng phải lớn hơn hoặc bằng sản lượng phân bổ thành công. Vui lòng điều chỉnh sản lượng của đơn hàng'
  } else {
    error = ''
  }

  return error
})

const submit = async () => {
  const api = $urlClient.order.order.updatePatch
  const dataBody = {
    productivityOrder: productivity.value
  }

  const data: any = await $api(api, { uriParams: { ID: orderId.value }, body: dataBody })
  const resData = data?.data?.value

  if (resData?.success) {
    const { productivityOrder, waitingForAllocation } = resData.data

    emits('update', {
      productivityOrder,
      waitingForAllocation
    })
    tooltip.value && tooltip.value.hide()
    process.client && $toast().success($t('labels.editSuccess'))
  }
}
</script>
